import { Employee } from '../bonus/types';
import { createIdbCache, QBA_CACHE_CONFIG } from '../../lib/idb';

const STORE = 'employee_cache';

const cache = createIdbCache<Employee[]>({ ...QBA_CACHE_CONFIG, storeName: STORE });

export const QBA_EMPLOYEE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export interface QbaEmployeeCacheKey {
  jobFamily:        string;
  applicationType?: string;
}

function buildKey(p: QbaEmployeeCacheKey): string {
  return `${p.jobFamily}|${p.applicationType ?? ''}`;
}

export const qbaEmployeeIdb = {
  get(params: QbaEmployeeCacheKey): Promise<Employee[] | null> {
    return cache.get(buildKey(params));
  },

  set(params: QbaEmployeeCacheKey, employees: Employee[]): Promise<void> {
    return cache.set(buildKey(params), employees, QBA_EMPLOYEE_TTL_MS);
  },

  invalidate(params: QbaEmployeeCacheKey): Promise<void> {
    return cache.delete(buildKey(params));
  },

  clearAll(): Promise<void> {
    return cache.clearAll();
  },
};